import {
    PublicKey,
} from '@solana/web3.js';

export const poolPublicKey = new PublicKey("6YeMu9oFUsXTXaxWsASr93CsKsFXQoT3mD12BTZVrGvY");

export const feeMintPublicKey = new PublicKey("ASTkbpe5ckW1mx6WDLE9zPScWsYjSh6h5zQ89UYoUQ7D");